import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Table, TBody, TR, TD } from 'oy-vey';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import EmailSignature from './EmailSignature';
import CurrencyView from '../modules/CurrencyView';
import { PRIMARY_COLOR } from '../../../constants';
import { textStyle, linkText, buttonStyle } from '../../../helpers/getEmailStyles';

import { url } from '../../../config';

class BookingRequestHost extends React.Component {

  static propTypes = {
    content: PropTypes.shape({
      reservationId: PropTypes.number.isRequired,
      confirmationCode: PropTypes.number.isRequired,
      hostName: PropTypes.string.isRequired,
      guestName: PropTypes.string.isRequired,
      checkIn: PropTypes.string.isRequired,
      checkOut: PropTypes.string.isRequired,
      listTitle: PropTypes.string.isRequired,
      basePrice: PropTypes.number.isRequired,
      total: PropTypes.number.isRequired,
      currency: PropTypes.string.isRequired,
      hostServiceFee: PropTypes.number.isRequired,
    }).isRequired

  };

  render() {
    const btnCenter = {
      textAlign: 'center'
    }
    const { content: { reservationId, confirmationCode, hostName, guestName, checkIn, checkOut, threadId, logo, siteName } } = this.props;
    const { content: { listTitle, basePrice, total, hostServiceFee, currency } } = this.props;

    let checkInDate = checkIn != null ? moment(checkIn).format('DD-MM-YYYY h:mm A') : '',
      checkOutDate = checkOut != null ? moment(checkOut).format('DD-MM-YYYY h:mm A') : '';
    let actionURL = url + '/message/' + threadId + '/host',
      subtotal = total - hostServiceFee;
    return (
      <Layout>
        <Header color={PRIMARY_COLOR} backgroundColor="#F7F7F7" logo={logo} siteName={siteName} />
        <div>
          <Table width="100%" >
            <TBody>
              <TR>
                <TD style={textStyle}>
                  <EmptySpace height={20} />
                  <div>
                    Hola {hostName},
                  </div>
                  <EmptySpace height={20} />
                  <div>
                    Buenas noticias! Tienes una nueva reserva ({confirmationCode}) de {guestName}
                  </div>
                  <EmptySpace height={10} />
                  <div>
                    {guestName} se quedaría en el {listTitle} desde {checkInDate} hasta {checkOutDate}.
                  </div>
                  <EmptySpace height={10} />
                  <div>
                    Basado en el precio de <CurrencyView amount={basePrice} currency={currency} />
                    {' '}por noche con el costo asociado, su pago estimado por esta reserva es <CurrencyView amount={subtotal} currency={currency} />
                  </div>
                  <EmptySpace height={40} />
                  <div style={btnCenter}>
                    <a href={actionURL} style={buttonStyle}>Aceptar o Rechazar</a>
                  </div>
                  <EmptySpace height={40} />
                  <EmailSignature siteName={siteName} />
                </TD>
              </TR>
            </TBody>
          </Table>
          <EmptySpace height={40} />
        </div>
        <Footer siteName={siteName} />
        <EmptySpace height={20} />
      </Layout>
    );
  }

}

export default BookingRequestHost;